<template>

<div>

    <ul class="pagination">
        <li class="page-item">
            <button @click='setPage( page - 1 )' class="page-link" >Предишна</button>
        </li>
        
        <li v-if='pages >= 1' :class="['page-item', { active : page == 1 }]">
            <button @click='setPage(1)' class="page-link">
                1
            </button>
        </li>
        
        <li v-if='pages > 7 && page > 4' :class="['page-item', { active : page == 1 }]">
            <button @click='setPage( page - 3 )' class="page-link">
                ..
            </button>
        </li>
        
        <li v-for='n in pages' v-if='shouldShow(n)' :class="['page-item', { active : page == n }]">
            <button @click='setPage(n)' class="page-link">
                {{ n }}
            </button>
        </li>

        <li v-if='pages > 7 && page < pages - 3' :class="['page-item', { active : page == 1 }]">
            <button @click='setPage( page + 3 )' class="page-link">
                ..
            </button>
        </li>
           
        <li v-if='pages >= 1' :class="['page-item', { active : page == pages }]">
            <button @click='setPage( pages )' class="page-link">
                {{ pages }}
            </button>
        </li>
        

        <li class="page-item">
            <button @click='setPage( page + 1)' class="page-link" >Следваща</button>
        </li>
    </ul>

</div>

</template>

<script>
    export default {

        mounted() {

        },

        props : [
            'total',
            'perPage',
        ],

        created() {
                
            this.pages = Math.ceil( this.total / this.perPage );


        },

        data() {

            return {

                pages : 1,
                page  : 1,

            }

        },

        methods : {

            setPage( p ) {

                if( p < 1 || p > this.pages ) {
                    p = 1;
                }

                if( p == this.page ) {
                    return;
                }

                this.page = p;

                this.$emit('page-change', p );
            },

            shouldShow( n ) {
                if( n == 1 || n == this.pages ) {
                    return false;
                }

                if( Math.abs( n - this.page ) < 3 ) {
                    return true;
                }

                return false;
            }

        }

    }
</script>
<style type="text/css">
    
</style>